// extracted by mini-css-extract-plugin
module.exports = {"root":"_3207b9b4","small":"_9a1d47ef","expand":"_6b5486e4"};